<div class="flex align-items-center justify-content-center"
  [ngClass]="iohShowFilter() ? 'ioh-filter-button-toggle' : 'ioh-filter-button'">
  <span class="ioh-filter-icon" [ngClass]="
      iohFilterFormService.isIohFilterApplied
        ? 'csx-ic_rtop_filter_selected'
        : 'csx-ic_rtop_filter_default'
    " (click)="onShowFilterClicked()"></span>
</div>

<div *ngIf="iohShowFilter()" class="ioh-filter-wrapper">
  <div class="ioh-filter-header-wrapper">
    <div class="ioh-filter-header-template">
      <p>Assets Filter</p>
      <a href="javascript:void(0)" *ngIf="iohFilterFormService.isIohFilterApplied" class="clear-all-link"
        (click)="resetFilterValue()">Reset</a>
    </div>
  </div>

  <ng-container>
    <div class="ioh-filter-body-wrapper" [ngStyle]="{ paddingTop: '60px' }">
      <div class="ioh-filter-block">
        <div class="ioh-filter-header">Find A Train</div>
        <div class="ioh-filter-body" style="flex-direction: row; margin-left: 0">
          <div class="p-element p-autocomplete-input p-inputtext p-component intermodal-custom-input" *ngIf="
              iohFilterFormService.iohFilterFormGroup.controls[
                'iohInputForSearch'
              ].value
            ">
            <div>
              {{ searchIdModel() }}
            </div>
            <i class="pi pi-times" (click)="clearIdSearch()"></i>
          </div>
          <p-autoComplete *ngIf="
              !iohFilterFormService.iohFilterFormGroup.controls[
                'iohInputForSearch'
              ].value
            " [ngModel]="searchIdModel()" [showEmptyMessage]="true" [suggestions]="filteredTrainList()"
            [style]="{ width: '100%' }" [inputStyle]="{ width: '100%' }" (completeMethod)="iohFilterSearchForId($event)"
            minLength="1" maxlength="6" #autocomplete (ngModelChange)="searchIdModel.set($event.toUpperCase())"
            (onFocus)="
              iohFilterSearchForId($event); autocomplete.handleDropdownClick()
            " (onSelect)="handleSelection($event)" (keydown.enter)="handleSelection($event)" appendTo="body"
            [autoHighlight]="true" class="ioh-filter-autocomplete">
          </p-autoComplete>
        </div>
      </div>

      <form [formGroup]="iohFilterFormService.iohFilterFormGroup">
        <div class="ioh-filter-container">
          <p-accordion class="ioh-filter-accordion" [multiple]="true"
            [transitionOptions]="'400ms cubic-bezier(0.86, 0, 0.07, 1)'" [motionOptions]="{ safe: false }"
            [value]="['0', '1','2','3','4']">
            <p-accordion-panel value="0">
              <p-accordion-header>
                <span>Performance</span>
              </p-accordion-header>
              <p-accordion-content>
                <!-- train performance start-->
                <div class="ioh-filter-block">
                  <div class="ioh-filter-body" formArrayName="performance">
                    <ng-container *ngFor="
                        let performanceControl of iohFilterFormService.performanceControl;
                        let index = index
                      ">
                      <div class="flex align-items-center gap-10">
                        <p-checkbox class="intermodal-checkbox" [formControlName]="index" [value]="
                            iohFilterFormService.trainPerformanceOptions[index]
                              .value
                          " [name]="performanceGroup" (onChange)="onFilterChange($event)"
                          [inputId]="'performance-' + index"></p-checkbox>
                        <p-badge badgeSize="small" value="&nbsp;" class="p-circle" [severity]="
                         iohFilterFormService.trainPerformanceOptions[
                           index
                          ].severity
                         ">
                        </p-badge>
                        <label for="performance-{{ index }}" [ngClass]="
                            iohAppService.iohFilterTrainsCountByLevel[level()][
                              iohFilterFormService.trainPerformanceOptions[
                                index
                              ].filterKey
                            ] === 0 ||
                            iohFilterFormService.iohFilterFormGroup.controls[
                              'iohInputForSearch'
                            ].value
                              ? 'disabled'
                              : ''
                          ">
                          <div class="flex align-items-center gap-10">
                            <div class="ioh-filter-label">
                              {{
                              iohFilterFormService.trainPerformanceOptions[
                              index
                              ].label
                              }}
                            </div>
                            <p-badge [severity]="
                                iohFilterFormService.trainPerformanceOptions[
                                  index
                                ].severity
                              " [value]="performanceBadgeValues()[index]"></p-badge>
                          </div>
                        </label>
                      </div>
                    </ng-container>
                  </div>
                  <!-- Late sub-filters -->
                  <div class="ioh-filter-block ioh-late-sub-filters" *ngIf="isLateSelected()">
                    <div class="ioh-filter-sub-header">Late By</div>
                    <div class="ioh-filter-body" formArrayName="lateSubFilters">
                      <ng-container *ngFor="
                          let lateSubFilterControl of iohFilterFormService.lateSubFiltersControl;
                          let index = index
                        ">
                        <div class="flex align-items-center gap-10 ioh-sub-filter-item">
                          <p-checkbox class="intermodal-checkbox" [formControlName]="index" [value]="
                              iohFilterFormService.lateSubFilterOptions[index]
                                .value
                            " [name]="'lateSubFilters'" (onChange)="onFilterChange($event)"
                            [inputId]="'lateSubFilter-' + index"></p-checkbox>
                          <label for="lateSubFilter-{{ index }}" class="ioh-filter-sub-label">
                            <div class="flex align-items-center gap-10">
                              <div class="ioh-filter-label">
                                {{
                                iohFilterFormService.lateSubFilterOptions[
                                index
                                ].label
                                }}
                              </div>
                              <p-badge severity="danger" [value]="lateSubFilterBadgeValues()[index]"></p-badge>
                            </div>
                          </label>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <!-- Late sub-filters end -->
                </div>
                <!-- train performance end-->
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="1">
              <p-accordion-header>
                <span>Commodity</span>
              </p-accordion-header>
              <p-accordion-content>
                <!-- Commodity start-->
                <div class="ioh-filter-block">
                  <ng-container *ngIf="iohFilterFormService.isCommodityApiFailed">
                    <div class="ioh-api-failure-response-container">
                      <div class="ioh-response-container-header">
                        <i class="csx-common_ban"></i>
                        <h1>Error</h1>
                      </div>
                      <p class="ioh-filter-label">
                        <b>{{
                          iohFilterFormService.iohCommodityApiErrorCode
                          }}: </b>An Error has occurred with the API. Commodities are
                        currently unavailable.
                      </p>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="iohFilterFormService.commodityFilterOptions?.length">
                    <div class="ioh-filter-body" formArrayName="commodities">
                      <ng-container *ngFor="
                          let commoditiesControl of iohFilterFormService.commoditiesDelayControl;
                          let index = index
                        ">
                        <div class="flex align-items-center gap-10" *ngIf="
                            iohFilterFormService.commodityFilterOptions[index]
                              .show
                          ">
                          <p-checkbox class="intermodal-checkbox" [formControlName]="index"
                            (onChange)="onFilterChange($event)" [value]="
                              iohFilterFormService.commodityFilterOptions[index]
                                .value
                            " [name]="commoditiesGroup" [inputId]="'commodity-' + index"></p-checkbox>
                          <label for="commodity-{{ index }}" [ngClass]="
                              iohAppService.iohFilterTrainsCountByLevel[
                                level()
                              ][
                                iohFilterFormService.commodityFilterOptions[
                                  index
                                ].filterKey
                              ] === 0 ||
                              iohFilterFormService.iohFilterFormGroup.controls[
                                'iohInputForSearch'
                              ].value
                                ? 'disabled'
                                : ''
                            ">
                            <div class="flex align-items-center gap-10">
                              <div class="ioh-filter-label">
                                {{
                                iohFilterFormService.commodityFilterOptions[
                                index
                                ].label | titlecase
                                }}
                              </div>
                              <p-badge [severity]="
                                  iohFilterFormService.commodityFilterOptions[
                                    index
                                  ].severity
                                " [value]="commodityBadgeValues()[index]"></p-badge>
                            </div>
                          </label>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
                <!-- Commodity end -->
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="2">
              <p-accordion-header>
                <span class="accordion-header">Train Groups</span>
              </p-accordion-header>
              <p-accordion-content>
                <!-- Train Groups start -->
                <div class="ioh-filter-block">
                  <div class="ioh-filter-body">
                    <div class="ioh-field-radio">
                      <div class="ioh-field-radio-container">
                        <p-radioButton class="intermodal-radiobutton" [inputId]="''" [value]="''"
                          (click)="onFilterChange($event)" [name]="'trainGroupGroup'" [ngModel]="selectedTrainGroup()"
                          [disabled]="
                          iohAppService.iohFilterTrainsCountByLevel[level()]['TOTAL_TRAIN_GROUPS'] === 0
                        " (ngModelChange)="selectedTrainGroup.set($event); onTrainGroupChange($event)"
                          [ngModelOptions]="{ standalone: true }"></p-radioButton>
                        <label [for]="''" class="ioh-filter-label ml-2" [ngClass]="
                          iohAppService.iohFilterTrainsCountByLevel[level()]['TOTAL_TRAIN_GROUPS'] === 0
                            ? 'disabled'
                            : ''
                        ">
                          All Trains
                        </label>
                        <p-badge class="ml-2"
                          [value]="iohAppService.iohFilterTrainsCountByLevel[level()]['TOTAL_TRAIN_GROUPS']" />
                      </div>
                    </div>
                    <!-- Ups trains start-->
                    <div class="ioh-field-radio">
                      <div class="ioh-field-radio-container">
                        <p-radioButton class="intermodal-radiobutton" [inputId]="'UpsTrain'" [value]="'UpsTrain'"
                          [name]="'trainGroupGroup'" [ngModel]="selectedTrainGroup()" [disabled]="
                          iohAppService.iohFilterTrainsCountByLevel[level()]['TOTAL_UPS_TRAINS'] === 0
                        " (ngModelChange)="selectedTrainGroup.set($event); onTrainGroupChange($event)"
                          [ngModelOptions]="{ standalone: true }"></p-radioButton>
                        <label [for]="''" class="ioh-filter-label ml-2" [ngClass]="
                          iohAppService.iohFilterTrainsCountByLevel[level()]['TOTAL_UPS_TRAINS'] === 0
                            ? 'disabled'
                            : ''
                        ">
                          UPS Trains
                        </label>

                        <!-- <div
                        class="ioh-custom-count-pill ml-2"
                        [style.background]="'#B3CDFB'"
                        [ngClass]="
                          iohAppService.iohFilterTrainsCountByLevel[level()]['TOTAL_UPS_TRAINS'] === 0
                            ? 'disabled'
                            : ''
                        "
                      >
                        {{ iohAppService.iohFilterTrainsCountByLevel[level()]['TOTAL_UPS_TRAINS'] }}
                      </div> -->
                        <p-badge class="ml-2"
                          [value]="iohAppService.iohFilterTrainsCountByLevel[level()]['TOTAL_UPS_TRAINS']" />
                      </div>
                    </div>
                    <!-- Ups trains end-->
                  </div>
                </div>
                <!-- Train Groups end-->
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel [selected]="true" value="3">
              <p-accordion-header>
                <span class="accordion-header">Train Stoppage</span>
              </p-accordion-header>
              <p-accordion-content>
                <!-- Train Stoppage start-->
                <div class="ioh-filter-block">
                  <div class="ioh-filter-body" formArrayName="trainStoppage">
                    @for ( trainStoppageControl of iohFilterFormService.trainStoppageControl; track
                    trainStoppageControl; let index = $index ) {
                    <div class="flex align-items-start gap-10">
                      <p-checkbox class="intermodal-checkbox" (onChange)="onFilterChange($event)"
                        [value]="iohFilterFormService.trainStoppageOptions[index].value" [name]="trainStoppageGroup"
                        [formControl]="trainStoppageControl"></p-checkbox>
                      <label for="trainStoppageControl.label">
                        <div class="flex gap-10">
                          <div class="flex flex-column" style="gap: 4px">
                            <div class="flex align-items-center gap-10" [ngClass]="
                              iohFilterFormService.iohFilterFormGroup.controls['iohInputForSearch'].value
                                ? 'disabled'
                                : ''
                            ">
                              <div class="filter-label">
                                {{ iohFilterFormService.trainStoppageOptions[index].label }}
                              </div>

                              <p-badge severity="{{
                                iohFilterFormService.trainStoppageOptions[index].severity
                              }}" [value]="
                                iohAppService.iohFilterTrainsCountByLevel[level()][
                                  iohFilterFormService.trainStoppageOptions[
                                    index
                                  ].filterKey.toUpperCase()
                                ] || 0
                                  | iohFilterTrainList

                                    : trainStoppageControl
                                    : true
                                    : iohFilterFormService.iohFilterFormGroup.controls['iohInputForSearch']
                                        .value
                              " />
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                    }
                  </div>
                </div>
                <!-- Train Stoppage end-->
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel [selected]="true" value="4">
              <p-accordion-header>
                <span class="accordion-header">Train Length</span>
              </p-accordion-header>
              <p-accordion-content>
                <!-- Train Length start-->
                <div class="ioh-filter-block">
                  <div class="ioh-filter-body" formArrayName="trainLengths">
                    @for ( trainLengthControl of iohFilterFormService.trainLengthsControl; track
                    trainLengthControl; let index = $index ) {
                    <div class="flex align-items-center gap-10">
                      <p-checkbox class="intermodal-checkbox" [formControl]="trainLengthControl"
                        [value]="iohFilterFormService.trainLengthOptions[index].value" [name]="trainLengthsGroup"
                        (onChange)="onFilterChange($event)"></p-checkbox>
                      <label for="iohFilterFormService.trainLengthOptions[index].label" [ngClass]="
                        iohFilterFormService.iohFilterFormGroup.controls['iohInputForSearch'].value
                          ? 'disabled'
                          : ''
                      ">
                        <div class="flex align-items-center gap-10">
                          <div class="legend-indicator train-length-container">
                            @for ( i of iohFilterFormService.trainLengthOptions[index].length; track i )
                            {
                            <div class="length-stick" [style.background-color]="i"></div>
                            }
                          </div>
                          <div class="filter-label">
                            {{ iohFilterFormService.trainLengthOptions[index].label }}
                          </div>
                          <p-badge [value]="
                            iohAppService.iohFilterTrainsCountByLevel[level()][
                              iohFilterFormService.trainLengthOptions[index].filterKey
                            ]
                              | iohFilterTrainList
                                : trainLengthControl
                                : true
                                : iohFilterFormService.iohFilterFormGroup.controls['iohInputForSearch'].value
                          "></p-badge>
                        </div>
                      </label>
                    </div>
                    }
                  </div>
                </div>
                <!-- Train Length end -->
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
      </form>

      <div class="ioh-filter-download-wrapper">
        <button
          type="button"
          pButton
          icon="pi pi-download"
          iconPos="right"
          class="p-button-text ioh-download-btn"
          label="Download Excel"
          (click)="handleDownloadExcel()"
        ></button>
      </div>
    </div>
  </ng-container>

  <div class="ioh-filter-footer-action">
    <p-button
      label="Save as default filter"
      (click)="handleSaveFilters()"
      [raised]="true"
      [disabled]="
        iohFilterFormService.iohFilterFormGroup.controls['iohInputForSearch'].value
          ? true
          : !isSaveEnabled()
      "
    />
  </div>

  <p-toast key="iohSaveFilters" position="top-center" />
</div>